import { CopyParagraph } from '@sleepstation/components-copy'
import { HList, VList } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import { baseline } from '@sleepstation/style-api-helpers'
import { renderList } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VList).attrs({ spacing: LAYOUT_SPACING.SMALL })``

const Icon = styled.div`
  border-radius: 50%;
  width: 8px;
  height: 8px;
  ${({ bgColor }) => ({
    backgroundColor: bgColor,
  })}
`

const Label = styled(CopyParagraph)`
  ${baseline(-2)}
`

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const Key = ({ keyList }) => (
  <Layout>
    {renderList(
      ({ label, color }) => (
        <HList spacing={LAYOUT_SPACING.SMALL} align={LAYOUT_ALIGN.CENTER}>
          <Icon bgColor={color} />
          <Label>{label}</Label>
        </HList>
      ),
      keyList
    )}
  </Layout>
)

Key.propTypes = {
  keyList: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default Key
